import type { OverviewStatsResponseDto } from '@lunary/api-client'
import { HBars } from '../../shared/ui/charts/hbars'
import { formatNumber } from '../../shared/ui/charts/scale'
import { StackedBars } from '../../shared/ui/charts/stacked-bars'
import { roleLabel, sourceLabel } from '../users/labels'
import { SOURCE_SERIES, indexBy } from './series'
import styles from './overview.module.css'

export function UsersSection({ data, days }: { data: OverviewStatsResponseDto; days: readonly string[] }) {
  const value = indexBy(data.new_by_day, (r) => r.source, (r) => r.count)
  const present = SOURCE_SERIES.filter((s) => data.new_by_day.some((r) => r.source === s.key))
  const series = present.length > 0 ? present : SOURCE_SERIES.slice(0, 4)

  return (
    <section className={styles.section} aria-labelledby="ov-users">
      <h2 id="ov-users">Новые пользователи</h2>
      <div className={styles.split}>
        <div className="card-panel">
          <p className={styles.caption}>Регистрации по дням и источнику, без гостей</p>
          <StackedBars label="Новые пользователи по дням и источникам" days={days} series={series} value={value} />
          <details className={styles.table}>
            <summary>Таблица</summary>
            <table className="users-table">
              <thead>
                <tr>
                  <th>День</th>
                  {series.map((s) => (
                    <th key={s.key}>{s.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {days
                  .filter((d) => series.some((s) => value(d, s.key) > 0))
                  .map((d) => (
                    <tr key={d}>
                      <td>{d}</td>
                      {series.map((s) => (
                        <td key={s.key}>{formatNumber(value(d, s.key))}</td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </details>
        </div>
        <div className="card-panel">
          <p className={styles.caption}>Откуда пришли (все время)</p>
          <HBars
            label="Пользователи по источникам"
            color="var(--series-1)"
            items={data.by_source.map((r) => ({ key: r.key, label: sourceLabel(r.key), value: r.count }))}
          />
          <p className={styles.caption} style={{ marginTop: 20 }}>
            Роли
          </p>
          <HBars
            label="Пользователи по ролям"
            color="var(--accent)"
            items={data.by_role.map((r) => ({ key: r.key, label: roleLabel(r.key), value: r.count }))}
          />
        </div>
      </div>
    </section>
  )
}
